"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _alyceTheme = require("../../theme/alyce-theme");

var _BaseButton = _interopRequireDefault(require("./BaseButton"));

/**
 * SubmitButton.
 *
 * @deprecated
 *
 * @param {object} props
 * @param {React.ReactNode} [props.children=null]
 * @returns {JSX.Element}
 *
 * @example
 * //TODO: Write example.
 */
var SubmitButton = function SubmitButton(_ref) {
  var children = _ref.children,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["children"]);
  return /*#__PURE__*/_react["default"].createElement(_BaseButton["default"], (0, _extends2["default"])({
    variant: "outlined",
    color: _alyceTheme.palette.primary.main,
    hoverColor: _alyceTheme.palette.primary.main,
    bgColor: _alyceTheme.palette.secondary.main,
    hoverBgColor: _alyceTheme.palette.secondary.dark,
    border: "none !important"
  }, otherProps), children);
};

SubmitButton.propTypes = {
  children: _propTypes["default"].node
};
SubmitButton.defaultProps = {
  children: null
};
var _default = SubmitButton;
exports["default"] = _default;